import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { Link, useHistory, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Langpref from "./Langpref";
import imgUrl from "../../assets/images/imageUrl.js";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Services from "../../api/api";
import OffileDb from '../../config/pouchDB';
import Loader from "../loaders/loader";

import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import Header from "./Header";
import IconButton from '@material-ui/core/IconButton';
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';
import { settemplateID } from "../../redux/actions/appActions";
import Teamp1Termspage from './Teamp1Termspage';
import ThemeSwitcher from "../ThemeSwitcher";
import { gaLogEvent } from "../../helpers/analytics";
import { signInAnonymously } from "../../helpers/auth";
import { auth } from "../../service/firebase";


class Onboarding extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      templateID: props.templateID,
      appversion: "1.0.0",
      headerLogo: imgUrl.logo,
      footerLogo: imgUrl.poweredby,
      brandaing: [],
      headerBackButton: false,
      checkTosVal: false,
      checkedPrivacy: false,
      contentList: null,
    };
    this.handleCheckTos = this.handleCheckTos.bind(this);
    this.handlePrivacyCheck = this.handlePrivacyCheck.bind(this);
  }


  componentDidMount() {
    OffileDb.setDatabase()
    gaLogEvent("Registration", '', '');
    this.getTemplateID()

    let deviceuuid = localStorage.getItem('deviceuuid');
    localStorage.removeItem("firstBleeding");
    if (!localStorage.getItem('BotInnit')) {
      localStorage.setItem('BotInnit', "false");
    }
    localStorage.setItem('isGreeted', "false");
    let userObj = JSON.parse(localStorage.getItem('obj'));
    if (deviceuuid && userObj && userObj.roleType == 'Admin') {
      this.handleAdminLogout();
    }else if (deviceuuid && userObj) {
      this.props.history.push("/layout");
    } else {
      // this.checkUserExist()
    }
    this.getAppVersion();
    this.getAppLogos();
    this.getContentListByCommunityId();

    const CommunityId = localStorage.getItem('CommunityId');
    if (CommunityId) {
      this.setState({ headerBackButton: true })
    } else {
      this.setState({ headerBackButton: false })
    }
  }

  handleAdminLogout() {
    var self = this;
    OffileDb.deleteDatabse();
    setTimeout(function () {
      localStorage.removeItem('adminobj')
      self.setState({ adminObj: {} });
      localStorage.setItem('obj', localStorage.getItem('tempuserobj'))
      self.getUserDeatils(JSON.parse(localStorage.getItem("tempuserobj")).userId)
      localStorage.removeItem('tempuserobj')
      // self.props.history.push("/layout/userlogin");
    });
  }

  getUserDeatils(userId) {
    console.log("user cauught")
    var param = {
      "communityId": this.props.communityuid,
      "userId": userId
    }
    Services.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        if(res.data.data.profile && res.data.data.profile.nickName){
          signInAnonymously().then((s) => {
            auth().onAuthStateChanged((user) => {
              if (user) {
                user.updateProfile({
                  displayName: res.data.data.profile.nickName,
                }).then(function (s) {
                    console.log("updateProfile res>>", s);
                  }).catch(function (error) {
                    console.log("updateProfile error>>", error);
                  });
              }
            });
          }).catch((err) => console.log("err>>>", err));
        }
      }
      if(localStorage.getItem("loggedinname")){
        this.props.history.push("/layout/loginPin");
      }
      else{
      this.props.history.push("/layout/userlogin");}
    });
  }

  getTemplateID() {
    var para = {
      "communityId": this.props.communityuid,
    }
    Services.getTemplatesByCommunityId(para).then((res) => {
      try{
        if (res && res.data && res.data.status == 200 && res.data.data && res.data.data.templateList.length > 0) {
          var tempid = res.data.data.templateList.filter(obj=> obj.isDefault)
          if(tempid.length > 0 && tempid[0].templateId != this.props.templateID) {
            this.setState({ templateID: tempid[0].templateId });
            this.props.settemplateID(tempid[0].templateId)
          }
          this.setState({isLoading: false});
        } else {
          this.setState({isLoading: false});
        }
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  checkUserExist(param) {
    if (window.cordova) {
      var para = {
        "communityId": this.props.communityuid,
        "serialNumber": window.device.uuid //param.deviceDetails.serialNumber,
      }
      Services.checkIfApplicantExists(para).then((res) => {
        try{
          if (res && res.data.status == 200) {
            localStorage.setItem(
              "obj",
              JSON.stringify({
                roleId: res.data.data.roleId,
                roleType: res.data.data.roleType,
                userId: res.data.data.userId,
                userType: res.data.data.userType,
              })
            );
            localStorage.setItem("deviceuuid", window.device.uuid);
            this.props.history.push("/Thankspage1");
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    }
  }

  getAppVersion() {
    var param = {
      id: this.props.communityuid,
    };
    Services.getAppVersion(param).then((res) => {
      try{
        this.setState({ appversion: res.data.data.appVersion });
      }catch(err){
        console.log("err::", err)
      }
    })
  }

  getAppLogos() {
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.getCommunityBrandingByCommunityId(param).then((res) => {
        try{
          console.log(res)
          if (res.status == 200) {
            let hlogo = res.data.data.brandingDetails.filter(o => o.tagline == "headerlogo").map(o => o.icon)[0] || imgUrl.logo;
            let flogo = res.data.data.brandingDetails.filter(o => o.tagline == "footerlogo").map(o => o.icon)[0] || imgUrl.poweredby;
            this.setState({
              headerLogo: hlogo,
              footerLogo: flogo,
            });
            OffileDb.setData('applogos', res.data.data)
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    }
  }
  getContentListByCommunityId() {
    console.log("hi")
    if (navigator.onLine) {
      var param = {
        communityId: this.props.communityuid,
      };
      Services.contentListByCommunityId(param).then((res) => {
        try{
          console.log(res)
          if (res.status == 200) {
            console.log("contentListByCommunityId::", res.data.data.contentTypeList);
            var tempobj = res.data.data.contentTypeList;
            this.setState({ contentList: tempobj })
            localStorage.setItem('contentList', JSON.stringify(tempobj))
          }
        }catch(err){
          console.log("err::", err)
        }
      })
    } else {

    }
  }

  addGuestUser() {
    const { t } = this.props;
    if (navigator.onLine) {
      let uuid = uuidv4();
      localStorage.setItem("deviceuuid", uuid);
      var param = {
        communicationDetails: {
          fcmId: localStorage.getItem('fcmToken')
        },
        communityId: this.props.communityuid,
        deviceDetails: {
          serialNumber: uuid,
        },
        profile: {
          location: {
            coordinates: [this.state.lat, this.state.lng],
            type: "point",
          },
        },
        preferredLanguageId: this.props.langId,
        geoLocation: false
      };
      if (window.cordova) {
        param.deviceDetails['uuid'] = window.device.uuid
        param.deviceDetails['cordova'] = window.device.cordova
        param.deviceDetails['manufacturer'] = window.device.manufacturer
        param.deviceDetails['model'] = window.device.model
        param.deviceDetails['platform'] = window.device.platform
        param.deviceDetails['serialNumber'] = window.device.uuid
        param.deviceDetails['version'] = window.device.version
        localStorage.setItem("deviceuuid", window.device.uuid);
      }
      console.log(JSON.stringify(param))
      Services.addApplicant(param).then((res) => {
          if (res.data.status == 200) {
            localStorage.setItem(
              "obj",
              JSON.stringify({
                roleId: res.data.data.roleId,
                roleType: res.data.data.roleType,
                userId: res.data.data.userId,
                userType: res.data.data.userType,
              })
            );
            var contentList = JSON.parse(localStorage.getItem('contentList'));
            if (contentList.filter(obj => obj.contentId == 75 && obj.isactive).length > 0) {
              this.props.history.push("/Thankspage1");
            } else {
              this.props.history.push("/Thankspage1");
              //this.props.history.push("/layout");
            }
          }
       
      }).catch((error) => {
        console.log("getRequest err>>", error);
        this.checkUserExist()
      });
    } else {
      swal({
        title: t("Unstable internet connection"),
        text: t("please check network connection"),
        icon: "success",
        button: t("ok"),
      }).then((val) => {
      });
    }
  }

  handleCheckTos(val) {
    console.log(val)
    this.setState({ checkTosVal: val })
  }


  handlePrivacyCheck(val) {
    console.log(val)
    this.setState({ checkedPrivacy: val })
  }

  checkTosVal() {
    const { t } = this.props;
    const { templateID } = this.props;
    var contentList = JSON.parse(localStorage.getItem('contentList'));
    if (templateID != 1) {
      this.redirectToNextPage()
    } else {
      if (contentList.filter(obj => obj.contentId == 74 && obj.isactive).length > 0) {
        if (this.state.checkTosVal && this.state.checkedPrivacy) {
          this.redirectToNextPage()
        } else {
          swal({
            title:  t(this.getErrrmsg()),
            icon: "warning",
            button: t("ok")
          })
        }
      } else {
        this.redirectToNextPage()
      }
    }
  }


  getErrrmsg(){
    if(!this.state.checkedPrivacy && !this.state.checkTosVal) {
      return 'Please agree to the terms of service and privacy policy'
    } else if(!this.state.checkedPrivacy) {
      return 'Please agree to the privacy policy'
    } else {
      return 'Please agree to the terms of service'
    }
  }

  redirectToNextPage() {
    var self = this;
    const { templateID } = this.props;
    var contentList = JSON.parse(localStorage.getItem('contentList'));
    if (templateID != 1) {
      if (contentList.filter(obj => obj.contentId == 74 && obj.isactive).length > 0) {
        self.props.history.push(`/tos1`);
      } else if (contentList.filter(obj => obj.contentId == 76 && obj.isactive).length > 0) {
        self.props.history.push(`/Welcomemsgpage1`);
      } else if (contentList.filter(obj => obj.contentId == 73 && obj.isactive).length > 0) {
        if (contentList.filter(obj => obj.contentId == 73 && obj.isactive && obj.viewType == "Vertical view").length > 0) {
          self.props.history.push(`/OnboardingRegVertical`);
        } else {
          self.props.history.push(`/Onboardingslider`);
        }
      } else {
        this.addGuestUser();
      }
    } else {
      if (contentList.filter(obj => obj.contentId == 76 && obj.isactive).length > 0) {
        self.props.history.push(`/Welcomemsgpage1`);
      } else if (contentList.filter(obj => obj.contentId == 73 && obj.isactive).length > 0) {
        if (contentList.filter(obj => obj.contentId == 73 && obj.isactive && obj.viewType == "Vertical view").length > 0) {
          self.props.history.push(`/OnboardingRegVertical`);
        } else {
          self.props.history.push(`/Onboardingslider`);
        }
      } else {
        //self.props.history.push(`/Onboardingslider`);
        this.addGuestUser();
      }
    }
  }



  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    var contentList = this.state.contentList
    return (
      <>
        {this.state.isLoading ? (
          <>
            <Loader isLoading={this.state.isLoading} />
            <ThemeSwitcher chnageTheme={this.state.templateID} showcontent={false}></ThemeSwitcher>
          </>
        ) : (
          <div className="onboarding-page langpref-page fulllengthpage selectlangpage">
            <div className="gridcontainer">
              <Grid container spacing={3} className="gridcontainer">
                <Header></Header>
                <Grid item xs={12} className="onboardingsliderdivcontent">
                  {
                    templateID == 1 ? (
                      <Grid item xs={12} className="langdivholder">
                        <div className="px-30px">
                          <h4 className="text-left zero color-darkblue fw-500"><Trans> {t("Please Select Language")} </Trans></h4>
                        </div>
                        <Langpref></Langpref>
                      </Grid>
                    ) : (
                      <Langpref ></Langpref>
                    )
                  }

                  {
                    templateID == 1 && contentList && contentList.filter(obj => obj.contentId == 74 && obj.isactive).length > 0 && (
                      <Teamp1Termspage handleCheckTos={this.handleCheckTos} handlePrivacyCheck={this.handlePrivacyCheck} ></Teamp1Termspage>
                    )
                  }
                </Grid>
                <Grid item xs={12} className="stoptblogodiv w-100">
                  <p className="text-center mb-0 mt-0 powertext">
                    <img className="oneimpactlogoimg imgmiddle hide" src={imgUrl.poweredby} />Powered by Dure Technologies
                    </p>
                </Grid>
                <Grid item xs={12} className="text-center skipbtnholder zero">
                  <div className="getstarted-btn-holder">
                    <Link onClick={() => this.checkTosVal({})}>
                      <Button
                        color="primary"
                        disableElevation
                        className="login_btn animate__animated animate__backInUp animate__faster getstarted-btn"
                      >
                        <Trans> {t("next")} </Trans>
                      </Button>
                    </Link>
                  </div>
                </Grid>
              </Grid>
            </div>
          </div>
        )
        }
      </>
    );
  }
}

const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: {},
  };
};

// const ThemeKnowYourRights = withTheme(KnowYourRights);
// const FinalThemeKnowYourRights = withStyles(useStyles)(ThemeKnowYourRights);
//const routeSettings = withRouter(Settings);
//export default connect(mapStateToProps, {})(routeSettings);

//let themeSwitcherOnboarding = useThemeSwitcher(Onboarding)
let routeOnboarding = withRouter(Onboarding)
let transonboarding = withTranslation()(routeOnboarding);
export default connect(mapStateToProps, { settemplateID })(transonboarding);

